import { AustralianAccreditedLogo } from '@/components/chakraUIPro/AustralianAccreditedLogo';
import { GenaLogo } from '@/components/chakraUIPro/GenaLogo';
import { PeppolCertifiedLogo } from '@/components/chakraUIPro/PeppolCertifiedLogo';
import { VerifactuCertifiedLogo } from '@/components/chakraUIPro/VerifactuCertifiedLogo';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styles from '../../HomepageSections.module.scss';

export const AccreditationSection = () => {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.accreditationSection} aria-labelledby='accreditation-title'>
      <div className={styles.wideShell}>
        <div className={styles.accreditationHeader}>
          <h2 id='accreditation-title'>
            {t('homepage.accreditation.title')}
            <b>.</b>
          </h2>
          <p>{t('homepage.accreditation.description')}</p>
        </div>
        <div className={styles.accreditationLogos}>
          <div>
            <PeppolCertifiedLogo role='img' aria-label={t('homepage.accreditation.peppolAria')} color='currentColor' />
            <span>{t('homepage.accreditation.peppol')}</span>
          </div>
          <div>
            <GenaLogo role='img' aria-label={t('homepage.accreditation.genaAria')} color='currentColor' />
            <span>{t('homepage.accreditation.gena')}</span>
          </div>
          <div>
            <Image
              className={`${styles.accreditationLogoImage} ${styles.franceAccreditationLogo}`}
              src='/images/accreditations/fra.png'
              alt={t('homepage.accreditation.pdpAria')}
              width={240}
              height={112}
            />
            <span>{t('homepage.accreditation.pdp')}</span>
          </div>
          <div>
            <VerifactuCertifiedLogo
              role='img'
              aria-label={t('homepage.accreditation.verifactuAria')}
              color='currentColor'
            />
            <span>{t('homepage.accreditation.verifactu')}</span>
          </div>
          <div>
            <AustralianAccreditedLogo
              role='img'
              aria-label={t('homepage.accreditation.australiaAria')}
              color='currentColor'
            />
            <span>{t('homepage.accreditation.australia')}</span>
          </div>
          <div>
            <Image
              className={`${styles.accreditationLogoImage} ${styles.mdecAccreditationLogo}`}
              src='/images/accreditations/mys.png'
              alt={t('homepage.accreditation.mdecAria')}
              width={311}
              height={112}
            />
            <span>{t('homepage.accreditation.mdec')}</span>
          </div>
          <div className={styles.uaeBadge}>
            <strong>{t('homepage.accreditation.uaeCode')}</strong>
            <span>{t('homepage.accreditation.uae')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
